<template>
  <thead>
    <tr>
      <th
        colspan="1"
        class="pl-1"
      >{{ getTranslation('instructions.sport_betting') }}</th>

      <th colspan="3">{{ getTranslation('main.ticket_id') }}</th>

      <th colspan="1" />
      <th
        colspan="1"
        v-if="showPayinTax"
      >{{ getTranslation('main.stake') }}</th>

      <th
        colspan="1"
        v-if="showPayinTax"
      >{{ getTranslation('print.payin_tax') }}</th>

      <th colspan="1">{{ getTranslation('main.payin') }}</th>
    </tr>

    <tr class="text-uppercase">
      <th
        colspan="1"
        class="pl-1"
      >
        {{ getTranslation('ticket.' + ticketTypes[ticket.type]) }}
        {{ getTranslation('main.ticket') }}
      </th>

      <th colspan="3">{{ ticket.id }}</th>

      <th colspan="1" />

      <th
        colspan="1"
        v-if="showPayinTax"
      >{{ formatNumber(ticket.bet, 2, 2) }}</th>

      <th
        colspan="1"
        v-if="showPayinTax"
      >{{ formatNumber(ticket.payinTax, 2, 2) }}</th>

      <th colspan="1">
        {{ formatNumber(ticket.payin, 2, 2) }}
      </th>
    </tr>

    <tr class="is--dark text-uppercase">
      <th colspan="1" />
      <th colspan="1">{{ getTranslation('main.time') }}</th>
      <th colspan="1">{{ getTranslation('sport.match') }}</th>
      <th colspan="1">{{ getTranslation('match.bet') }}</th>
      <th colspan="1">{{ getTranslation('main.odd') }}</th>
      <th colspan="1">{{ getTranslation('match.bet_pick') }}</th>
      <th colspan="1">{{ getTranslation('main.result') }}</th>
      <th colspan="1">{{ getTranslation('main.status') }}</th>
      <th
        colspan="1"
        v-if="ticket.fullResultsEnabled"
      >&nbsp;</th>
    </tr>
  </thead>
</template>

<script>
import helpers from '../../../services/helpers';

export default {
  name: 'TicketCheckHeader',
  data() {
    return {
      ticketTypes: {
        1: 'combo',
        2: 'system',
        3: 'single',
      },
    };
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showPayinTax() {
      const { taxes } = this.$store.getters;
      return taxes.payin.value && !taxes.payin.hideTax && this.ticket.payinTax;
    },
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    formatNumber: helpers.formatNumber,
  },
};
</script>
